/** @module components/product-image-card */
import baustein from "baustein";
import productClickMixin from "./mixins/product-click-mixin";

import "web/script/components/lead-link";

/**
 * A product image card that just displays the image of the product.
 *
 * @constructor
 * @alias module:components/product-image-card
 * @extends module:baustein
 */
export default baustein.register(
    "product-image-card",
    /** @lends module:components/product-image-card.prototype */
    {
        mixins: [productClickMixin],

        defaultOptions: {
            overlayEnabled: false,
            productSlug: null,
            reason: null,
        },

        getClickOverlayClasses: function() {
            return [".product-image-card__link"];
        },
    }
);
